"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuComponent = _interopRequireDefault(require("./AuComponent"));
var _List = _interopRequireDefault(require("./List"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "named_list-module__container___s4pOp",
  "title": "named_list-module__title___L6P2H"
};
class NamedList extends _AuComponent.default {
  static propTypes = {
    titleId: T.string,
    titleString: T.string,
    list: T.array.isRequired
  };
  render() {
    const {
      titleId,
      titleString,
      list
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.container
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: titleId,
      displayString: titleString,
      className: styles.title,
      tag: "div"
    }), /*#__PURE__*/_react.default.createElement(_List.default, {
      list: list
    }));
  }
}
exports.default = NamedList;